'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var File = require('../File/File.js');
var context = require('./context.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Files
 *
 * Renders the files that are currently selected.
 */
// eslint-disable-next-line react/function-component-definition -- Needs to be a function for the generic type.
function Files(props) {
  var _useInputFileContext = context.useInputFileContext(),
    value = _useInputFileContext.value,
    getFileProps = _useInputFileContext.getFileProps;
  if (!value || value.length === 0) {
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(react.Flex, _extends__default["default"]({
    mt: 2,
    gap: 2
  }, props), value.map(function (_value) {
    return /*#__PURE__*/React__default["default"].createElement(File.File, getFileProps({
      value: _value
    }));
  }));
}
exports.Files = Files;